import styles from './style.module.scss';
function Loader() {
    return (
        <div className={styles.bodyLoader}>
            <span className={styles.loader}></span>
        </div>
    );
}

export default Loader;
